const centreSelect = (() => {
    const initBlock = el => {        
        el.addEventListener('change', (e) => {
            window.location.href = e.target.value;
        });        
    };
    return {
        initBlock
    };
})();
ControlBinders.register(`[data-centre-select]`, el => centreSelect.initBlock(el));